import script from "./ModalSolicitation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSolicitation.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSolicitation.vue?vue&type=style&index=0&id=151ce2f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151ce2f0"]])

export default __exports__